import { render, staticRenderFns } from "./WasteBinReadingsList.yaml?vue&type=template&id=38ffee4e&component"
import script from "./WasteBinReadingsList.yaml?vue&type=script&lang=ts&component"
export * from "./WasteBinReadingsList.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports